import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { tt } from '../lib/empresasTxt';

export default function Footer() {
  const { t, i18n } = useTranslation();
  return (
    <footer className="footer">
      <div>{t('footer.copyright')}</div>
      <div className="footer-right">
        <span className="footer-meta">{t('footer.tagline')}</span>
        <Link to="/empresas" className="footer-staff-link">{tt((i18n.resolvedLanguage || 'es').toLowerCase(), 'eyebrow')}</Link>
        <Link to="/admin" className="footer-staff-link">{t('footer.acceso_staff')}</Link>
      </div>
    </footer>
  );
}
